import { Button, makeStyles } from "@material-ui/core";
import { CalendlyEventListener, InlineWidget } from "react-calendly";
import { moveNextPage, updateCreatorOnboarding } from "../../../../../store/actions/creator/creatorOnBoarding";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../../../../config/config";
import { useEffect, useState } from "react";
import UtilService from "../../../../../helper/service";
import { useHistory, useLocation } from "react-router";

type CalendlyEventListenerJSX = (props: CalendlyEventListener['props']) => any;

const CustomCalendlyEventListener = CalendlyEventListener as any as CalendlyEventListenerJSX;

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      margin: 0,
      maxWidth: 800,
      textAlign: 'center',
      fontSize: 36,
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      lineHeight: 1.25,
      '@media (max-width: 600px)': {
        fontSize: '25px!important',
      },
    },
  },
  description: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      margin: 0,
      maxWidth: 880,
      fontFamily: 'roboto-light',
      fontSize: 24,
      color: '#212D40',
      textAlign: 'center',
      lineHeight: 1.25,
      '@media (max-width: 600px)': {
        fontSize: 15,
      },
    },
  },
  bookingWords: {
    fontFamily: 'roboto-light',
    fontSize: 20,
    color: '#212D40',
    '@media (max-width: 600px)': {
      fontSize: 15,
    },
  },
  arrow: {
    width: 150,
    height: 50,
    marginTop: 6,
    '@media (max-width: 1150px)': {
      display: 'none'
    },
  },
  memberImg: {
    width: '280px',
    height: 'auto',
    marginTop: 10
  },
  imgDiv: {
    marginTop: 70,
    marginLeft: (props: any) => props.width < 1470 ? -50 : -70,
    zIndex: 100,
    '@media (max-width: 600px)': {
      marginLeft: 0,
      width: 'calc(100% - 40px)'
    },
  },
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    width: 180,
    height: 45,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    marginLeft: 20,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 600px)': {
      width: 'auto',
      height: 'auto',
      padding: '3px 12px',
      fontSize: 11,
      marginLeft: 12
    },
  },
  calendar: {
    minWidth: 1000,
    height: 664,
    marginLeft: -50,
    position: 'relative',
    '@media (max-width: 780px)': {
      minWidth: 0,
      marginLeft: 0,
    },
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 1150px)': {
      flexDirection: 'column',
    },
  },
  hiddenBar: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: 50,
    background: 'white',
    '@media (max-width: 780px)': {
      width: 0
    },
  }
}));

const Module3Slide1 = () => {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  // the firstName/lastName will be saved when press Next button on the onboarding first page
  const firstName = localStorage.getItem('firstName') ? localStorage.getItem('firstName') : '';
  const lastName = localStorage.getItem('lastName') ? localStorage.getItem('lastName') : '';

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [timeSelected, setTimeSelected] = useState(false);

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm3s1');
  }, []);

  useEffect(() => {
    if (firstName && lastName) {
      setFullName(
        `${UtilService.capitalizeFirstLetter(firstName)} ${UtilService.capitalizeFirstLetter(lastName)}`
      );
    } else {
      setFullName(
        `${UtilService.capitalizeFirstLetter(loginUserData.first_name)} ${UtilService.capitalizeFirstLetter(loginUserData.last_name)}`
      )
    }
    loginUserData && setEmail(loginUserData.username)
  }, [firstName, lastName, loginUserData]);

  const onEventScheduled = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.calendlyevent.id,
      preference_name: 'CALENDLYEVENT',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 13) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '13',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(13))
  };

  const onSkipStep = () => {
    if (Number(activepage.value) < 14) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '14',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));

      const reqActiveStep = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activestep.id,
        preference_name: 'ACTIVESTEP',
        preference_information: '3',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActiveStep));
    }

    dispatch(moveNextPage(14))
  };

  const widget = <div className={classes.calendar}>
    <InlineWidget
      styles={{ width: '100%', height: '100%' }}
      pageSettings={{
        backgroundColor: 'ffffff',
        hideEventTypeDetails: true,
        hideLandingPageDetails: true,
        primaryColor: '017AEF',
        textColor: '4d5055'
      }}
      prefill={{
        email: email,
        name: fullName
      }}
      url={`${Config.CALENDLY_URL}`}
    />
    <div className={classes.hiddenBar} />
  </div>

  return (
    <div>
      <div className={classes.title}>
        <p>
          Welcome to Module 3! Here you’ll book a free
          “Data Debrief” with one of our expert team!
        </p>
      </div>
      <div className={classes.description}>
        <p>
          The consultation is a great opportunity to talk through the meaning of measurement
          results, ask any questions you have, and learn about features that will be helpful.
        </p>
      </div>
      <div className={classes.content}>
        <CustomCalendlyEventListener
          onEventScheduled={onEventScheduled}
          onDateAndTimeSelected={() => setTimeSelected(true)}
          {...{ children: widget }}
        />

        <div className={classes.imgDiv} style={{ marginLeft: size.width < 1150 ? 0 : timeSelected ? -50 : -180, }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img className={classes.arrow} src={'/assets/icons/onboarding/module3-slide1-arrow.svg'} alt={'Arrow'} />
            <span className={classes.bookingWords}>Book one of our available slots!</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <img className={classes.memberImg} src={'/assets/icons/onboarding/module3-slide1-members.svg'} alt={'Arrow'} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20, marginBottom: 30 }}>
              <div className={classes.bookingWords}>Can’t find a time?</div>
              <Button color='primary' size='large' className={classes.btn} onClick={onSkipStep}>
                Skip this Step
              </Button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
};

export default Module3Slide1;